/*
 * @FilePath: financeConfig.js
 * @Author: Aron
 * @Date: 2023-07-21 11:27:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-28 20:20:44
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
export default [
  {
    path: "AccountAssetsBoard",
    name: "AccountAssetsBoard",
    meta: {
      title: "账户资产看板"
    },
    component: () =>
      import("@/views/Home/financeCenter/AccountAssetsBoard")
  },
  {
    path: "AccountChange",
    name: "AccountChange",
    meta: {
      title: "账户变动通知"
    },
    component: () =>
      import("@/views/Home/financeCenter/AccountChange")
  },

  {
    path: "AccountBill",
    name: "AccountBill",
    meta: {
      title: "账户结算单"
    },
    component: () =>
      import("@/views/Home/financeCenter/AccountBill")
  },
  {
    path: "CreateAccountTogether",
    name: "CreateAccountTogether",
    meta: {
      title: "总部共建账户"
    },
    component: () =>
      import("@/views/Home/financeCenter/CreateAccountTogether")
  },
  {
    path: "RefundRecord",
    name: "RefundRecord",
    meta: {
      title: "退款记录"
    },
    component: () =>
      import("@/views/Home/financeCenter/RefoundRecord/index.vue")
  },
  {
    path: "AgentAccount",
    name: "AgentAcount",
    meta: {
      title: "现金账户"
    },
    component: () =>
      import("@/views/Home/financeCenter/AgentAccount/AgentAccount")
  },
  {
    path: "GoldManagement",
    name: "GoldManagement",
    meta: {
      title: "金账户管理"
    },
    component: () =>
      import("@/views/Home/financeCenter/GoldManagement/GoldManagement")
  },
  {
    path: "CollectWater",
    name: "CollectWater",
    meta: {
      title: "收款流水"
    },
    component: () =>
      import("@/views/Home/financeCenter/CollectWater/CollectWater")
  },
  {
    path: "CashAccountManage",
    name: "CashAccountManage",
    meta: {
      title: "提现账户管理"
    },
    component: () =>
      import("@/views/Home/financeCenter/CashAccountManage/CashAccountManage")
  },
  {
    path: "PaymentFlow",
    name: "PaymentFlow",
    meta: {
      title: "支付流水"
    },
    component: () =>
      import("@/views/Home/financeCenter/PaymentFlow/PaymentFlow")
  },
  {
    path: "DeliveryVoucherManage",
    name: "DeliveryVoucherManage",
    meta: {
      title: "提货券管理"
    },
    component: () =>
      import(
        "@/views/Home/financeCenter/DeliveryVoucherManage/DeliveryVoucherManage"
      )
  },
  {
    path: "DoubleOrderBalance",
    name: "DoubleOrderBalance",
    meta: {
      title: "双重订单账户余额"
    },
    component: () =>
      import("@/views/Home/financeCenter/DoubleOrderBalance/DoubleOrderBalance")
  },
  // {
  //   path: "DoubleOrderCreation",
  //   name: "DoubleOrderCreation",
  //   meta: {
  //     title: "创建双重订单"
  //   },
  //   component: () =>
  //     import(
  //       "@/views/Home/financeCenter/DoubleOrderBalance/DoubleOrderCreation/index.vue"
  //     )
  // },
  {
    path: "InvoiceHeader",
    name: "InvoiceHeader",
    meta: {
      title: "发票抬头"
    },
    component: () =>
      import("@/views/Home/financeCenter/InvoiceHeader/InvoiceHeader")
  },
  {
    path: "RequestWithdrawal",
    name: "RequestWithdrawal",
    meta: {
      title: "提现申请"
    },
    component: () =>
      import("@/views/Home/financeCenter/RequestWithdrawal")
  },
  {
    path: "ApplicationForCash",
    name: "ApplicationForCash",
    meta: {
      title: "转现金账户申请"
    },
    component: () =>
      import("@/views/Home/financeCenter/ApplicationForCash")
  },
  {
    // 样机指标查询
    path: "SampleIndexQuery",
    name: "SampleIndexQuery",
    component: () => import('@/views/Home/financeCenter/EquityManage/SampleIndexQuery'),
    meta: {
      title: "样机指标查询"
    }
  },
  {
    path: "EquityManagement",
    name: "EquityManagement",
    component: () => import('@/views/Home/financeCenter/EquityManagement'),
    meta: {
      title: "权益管理"
    }
  },
  {
    path: "EquityDetails",
    name: "EquityDetails",
    component: () => import('@/views/Home/financeCenter/EquityDetails'),
    meta: {
      title: "权益管理详情"
    }
  },
  {
    path: "VisitReimbursement",
    name: "VisitReimbursement",
    meta: {
      title: "参访报销"
    },
    component: () =>
      import("@/views/Home/financeCenter/VisitReimbursement")
  },
  {
    path: "VisitReimbursementApply",
    name: "VisitReimbursementApply",
    meta: {
      title: "报销申请"
    },
    component: () =>
      import("@/views/Home/financeCenter/VisitReimbursementApply")
  },
];
